import * as Sentry from '@sentry/react';
import { useContext, useEffect } from 'react';

import { UserInfoContext } from '~/context/user';

import { env } from './runtimeEnv';

export const SentryConfig = () => {
  const { userInfo } = useContext(UserInfoContext);

  useEffect(() => {
    const dsn = env('SENTRY_DSN');

    if (userInfo && dsn) {
      Sentry.init({
        dsn,
        integrations: [Sentry.browserTracingIntegration()],
        environment: env('ENVIRONMENT'),
        tracesSampleRate: 0.0,
      });

      Sentry.getCurrentScope().setUser({ ...userInfo });
    }
  }, [userInfo]);

  return null;
};
